// A task group's toolchains and its own worker image (D90).
import type { Toolchain } from "../../../../catalog/types";

export default {
  title: "Toolchains",
  description: "Tools the group's own worker image adds, so every step has them",
  loadFailed: "Could not load the toolchains",
  none: "The platform's image",
  scriptChip: "Setup script",
  state: { building: "Building", failed: "Build failed" },
  presets: "Toolchains",
  hints: {
    rust: "rustup, cargo, clippy and rustfmt; a repository's rust-toolchain.toml works",
    go: "The current Go release",
    java: "OpenJDK 17 and Maven; Gradle wrappers work",
    bazel: "Bazelisk as bazel; the repository's .bazelversion picks the release",
  } satisfies Record<Toolchain, string>,
  requiredByWorkflow: "Required by the workflow",
  script: "Setup script",
  scriptPlaceholder: "apt-get update && apt-get install -y --no-install-recommends postgresql-client",
  scriptHint: "Bash, run as root while the image builds, after the toolchains. Anything it installs is there in every step.",
  scriptLocked: "Only someone who may customise worker images can change this script; you can still change the toolchains.",
  saved: "Toolchains saved. The next task builds the image.",
  missingRequired: "The workflow requires a toolchain that is not selected: tasks cannot start until it is.",
  appliesNext: "The next task builds the image with these; tasks already running keep theirs.",
  save: "Save toolchains",
  rebuildQueued: "The next task builds the image again.",
  notBuilt: "Not built yet: the next task that starts builds it, then every step runs on it.",
  building: (since: string) => `Building since ${since}. Tasks wait for it.`,
  ready: (at: string) => `Ready since ${at}`,
  failed: (at: string) => `The build failed (${at}). Tasks fail until it is rebuilt or 10 minutes pass.`,
  buildOutput: "Build output",
  rebuild: "Rebuild",
};
